//@flow
import React from 'react'
import styled from 'styled-components'
import ElementRenderer from './ElementRenderer'

const Container = styled.div`
  position: relative;
  display: flex;
  flex-grow: 1;
  justify-content: center;
  align-items: center;
  text-align: center;
  user-select: none;
`

/**
 * Interface for providing a question and question state to the ElementRenderer
 * @memberof components
 */
function QuestionRenderer({
  question,
  questionState,
}: {
  question: Question,
  questionState: RawLearnerAnswer,
}) {
  const { elements } = question.display
  return (
    <Container>
      {elements.map((element, i) =>
        <ElementRenderer questionState={questionState} {...element} key={i} />,
      )}
    </Container>
  )
}

export default QuestionRenderer



// WEBPACK FOOTER //
// ./src/components/QuestionRenderer.js